// extracted by mini-css-extract-plugin
export default {"form":"login_form__zKNMD","pageSection":"login_pageSection__l2CdP","btnSubmit":"login_btnSubmit__zDSW5","keyAuthorization":"login_keyAuthorization__rdNiJ"};